import React, {
  useCallback,
  useEffect,
  useReducer,
  useRef,
  useState,
} from 'react';
import {
  DatePickerComponent,
  Inputs,
  PaginationComponent,
  SelectComponet,
  Tables,
} from '../../../../../../Components';
import { ListProposalLogs } from '../../../../../../Services/ListProposalLogsService';
import {
  GetParams,
  bottomBoxComponentUpdate,
  getPublicDownloadableLink,
} from '../../../../../../Helper';
import { Spinner } from '../../../../../../Components';
import { useTranslation } from 'react-i18next';
import { TableActions } from '../../../../../../Enums';
import { ProposalHistoryViewDetailsDialog } from './ProposalHistoryUtilities';
import { OrganizationUserSearch } from '../../../../../../Services';
import moment from 'moment';
import { UnitsOperationTypeEnum } from '../../../../../../Enums';
import { AgentRoleEnum } from '../../../../../../Enums';
import { ButtonBase } from '@material-ui/core';
import PreviewProposalDialog from './ProposalHistoryUtilities/Dialogs/PreviewProposalDialog';
import { AddSmartProposalLog } from '../../../../../../Services/GeneratedProposals';

export const UnitProfileProposalHistoryComponent = ({
  parentTranslationPath,
  translationPath,
}) => {
  const { t } = useTranslation(parentTranslationPath);
  const searchTimer = useRef(null);
  const [loading, setLoading] = useState(false);
  const [proposalLogs, setProposalLogs] = useState([]);
  const [viewDetailsProposal, setViewDetailsProposal] = useState(false);
  const [activeitem, setActiveitem] = useState(false);
  const [activeRow, setActiveRow] = useState(null);
  const [isPreviewDialogOpen, setIsPreviewDialogOpen] = useState(false);
  const unitId = GetParams('id');
  const operationType = +GetParams('operationType');
  const reducer = useCallback((state, action) => {
    if (action.id !== 'edit') return { ...state, [action.id]: action.value };
    return {
      ...action.value,
    };
  }, []);

  const defaultFilter = {
    proposalName: null,
    templateName: null,
    date: null,
    lead: null,
    agent: null,
    pageIndex: 1,
    pageSize: 25,
    filterBy: 'CreatedOn',
    orderBy: 2,
  };

  const [isLoading, setIsLoading] = useReducer(reducer, {
    proposalName: false,
    date: false,
    lead: false,
    agent: false,
  });
  const [selected, setSelected] = useReducer(reducer, {
    proposalName: null,
    date: null,
    lead: null,
    agent: null,
  });
  const [data, setData] = useReducer(reducer, {
    proposalName: [],
    date: [],
    lead: [],
    agent: [],
  });
  const [filter, setFilter] = useState(defaultFilter);

  const onPageIndexChanged = (pageIndex) => {
    setFilter((item) => ({ ...item, pageIndex }));
  };
  const onPageSizeChanged = (pageSize) => {
    setFilter((item) => ({ ...item, pageIndex: 0, pageSize }));
  };

  const tableActionClicked = useCallback((actionEnum, item) => {
    if (actionEnum === TableActions.preview.key) {
      setIsPreviewDialogOpen(true);
    } else if (actionEnum === TableActions.downloadText.key) {
      try {
        AddSmartProposalLog({
          proposalFileId: activeRow.fileId,
          proposalFileName: activeRow.fileName,
          propertyName: activeRow.propertyName,
          unitIds: [+activeRow.unitId],
          receivers: activeRow.proposalReceivers.map((item) => ({
            name: item.name,
            email: item.email,
            receiverId: item.receiverId,
            proposalReceiverType: 2,
          })),
          actionType: 2,
          generateProposalType : activeRow.proposalType === "Original" ? 1 : 2,
          isFromSmartProposalLog: true
        });
        const link = document.createElement('a');
        link.setAttribute('download', item.fileName);
        link.href = getPublicDownloadableLink(
          item.fileId,
          item.sourceSystemUrl
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.error('Error downloading file:', error);
      }
    } else if (actionEnum === TableActions.view.key) {
      setViewDetailsProposal(true);
      setActiveitem(item);
    }
  });
  const getTableActions = () => {
    const list = [];
    if (activeRow && activeRow?.actionType?.toLowerCase() !== 'download') {
      list.push({
        enum: TableActions.view.key,
        isDisabled: false,
        externalComponent: null,
      });
    }
    list.push({
      enum: TableActions.downloadText.key,
      isDisabled: false,
      externalComponent: null,
    });
    list.push({
      enum: TableActions.preview.key,
      isDisabled: false,
      externalComponent: null,
    });
    return list;
  };
  const focusedRowChanged = useCallback(
    (activeRow) => {
      setActiveRow(proposalLogs?.result[activeRow] || null);
    },
    [proposalLogs]
  );

  const listProposalLogs = useCallback(async (value) => {
    setLoading(true);
    const body = {
      ...filter,
      unitId,
    };
    const res = await ListProposalLogs({ body });
    if (!(res && res.status && res.status !== 200)) {
      setProposalLogs(res);
    } else {
      setProposalLogs([]);
    }
    setLoading(false);
  });

  const getAgent = useCallback(async (value) => {
    setIsLoading({ id: 'agent', value: true });
    let userTypeId;
    if (operationType === UnitsOperationTypeEnum.sale.key)
      userTypeId = AgentRoleEnum.SaleAgent.key;
    else if (operationType === UnitsOperationTypeEnum.rent.key)
      userTypeId = AgentRoleEnum.LeaseAgent.key;

    const body = {
      pageIndex: 0,
      pageSize: 2,
      userStatusId: 2,
      userTypeId: userTypeId,
      name: value || '',
    };
    const res = await OrganizationUserSearch({ body });
    if (!(res && res.status && res.status !== 200)) {
      setData({ id: 'agent', value: res.result });
    } else {
      setData({ id: 'agent', value: [] });
    }
    setIsLoading({ id: 'agent', value: false });
  });
  const onClearedAllFiltersClick = useCallback(() => {
    setSelected({
      id: 'edit',
      value: {
        proposalName: null,
        date: null,
        lead: null,
        agent: null,
      },
    });
    setFilter(defaultFilter);
  });

  useEffect(() => {
    listProposalLogs();
  }, [filter]);

  useEffect(() => {
    getAgent();
  }, []);

  useEffect(() => {
    bottomBoxComponentUpdate(
      <PaginationComponent
        pageIndex={filter.pageIndex - 1}
        pageSize={filter.pageSize}
        totalCount={proposalLogs.totalCount || 0}
        onPageIndexChanged={onPageIndexChanged}
        onPageSizeChanged={onPageSizeChanged}
      />
    );
  });
  return (
    <>
      <Spinner isAbsolute isActive={loading} />
      <div className='mx-4 my-3'>
        <span className='c-primary my-3' style={{ fontSize: 'large' }}>
          {t(`Proposal-Tracking`)}
        </span>
        <div className='containerSearchFileds'>
          <div className='d-flex-column'>
            <div className='proposal-search-fields-wrapper '>
              <div className='w-33'>
                <Inputs
                  idRef='AgentRef'
                  labelValue={t(`SearchbyagentName`)}
                  inputPlaceholder={t(`SearchbyagentName`)}
                  value={selected?.agent || ' '}
                  onKeyUp={(e) => {
                    const { value } = e.target;
                    const trimmedLowerCaseValue = value.trim().toLowerCase();
                    if (searchTimer.current) clearTimeout(searchTimer.current);
                    searchTimer.current = setTimeout(() => {
                      setFilter((item) => ({
                        ...item,
                        agent: trimmedLowerCaseValue || null,
                      }));
                      setSelected({ id: 'agent', value: value || null });
                    }, 700);
                  }}
                  onInputChanged={(e) => {
                    const { value } = e.target;
                    setSelected({ id: 'agent', value: value || null });
                    setFilter((item) => ({ ...item, agent: value || null }));
                  }}
                  translationPath={translationPath}
                  parentTranslationPath={parentTranslationPath}
                />
              </div>
              <div className='w-33'>
                <Inputs
                  idRef='SearchByProposalNameRef'
                  // inputPlaceholder={t(`searchbyreceiver`)}
                  inputPlaceholder={`searchbyreceiver`}
                  labelValue={t(`searchbyreceiver`)}
                  value={selected?.lead || ' '}
                  onKeyUp={(e) => {
                    const { value } = e.target;
                    if (searchTimer.current) clearTimeout(searchTimer.current);
                    searchTimer.current = setTimeout(() => {
                      setFilter((item) => ({ ...item, lead: value || null }));
                      setSelected({ id: 'lead', value: value || null });
                    }, 700);
                  }}
                  onInputChanged={(e) => {
                    const { value } = e.target;
                    setSelected({ id: 'lead', value: value || null });
                    setFilter((item) => ({ ...item, lead: value || null }));
                  }}
                  translationPath={translationPath}
                  parentTranslationPath={parentTranslationPath}
                />
              </div>
              <div className='w-33'>
                <DatePickerComponent
                  idRef='activityDateRef'
                  placeholder='DD/MM/YYYY'
                  labelValue={t(`searchDate`)}
                  value={
                    (selected.date &&
                      moment(selected.date).isValid() &&
                      moment(selected.date)) ||
                    null
                  }
                  onDateChanged={(newValue) => {
                    setFilter((item) => ({
                      ...item,
                      date:
                        (newValue &&
                          moment(newValue).format('YYYY-MM-DDTHH:mm:ss')) ||
                        null,
                    }));
                    setSelected({
                      id: 'date',
                      value:
                        (newValue &&
                          moment(newValue).format('YYYY-MM-DDTHH:mm:ss')) ||
                        null,
                    });
                  }}
                />
              </div>
            </div>

            <div className='proposal-search-fields-wrapper '>
              <div className='w-33'>
                <SelectComponet
                  idRef={'action-type'}
                  labelValue={t(`action-type`)}
                  inputPlaceholder={t('select-action-type')}
                  data={[
                    {
                      id: 1,
                      actionType: 'share',
                    },
                    {
                      id: 2,
                      actionType: 'download',
                    },
                  ]}
                  valueInput='id'
                  textInput='actionType'
                  emptyItem={{
                    value: null,
                    text: 'select-filter-by',
                    isDisabled: false,
                  }}
                  value={filter?.actionType || null}
                  multiple={false}
                  withoutSearchButton={true}
                  translationPath={translationPath}
                  parentTranslationPath={parentTranslationPath}
                  onSelectChanged={(newValue) => {
                    setFilter((item) => ({
                      ...item,
                      actionType: newValue,
                    }));
                  }}
                />
              </div>
              <div className='w-33'>
                <SelectComponet
                  idRef={'proposal-type'}
                  labelValue={t(`proposal-type`)}
                  inputPlaceholder={t('select-proposal-type')}
                  data={[
                    {
                      id: 1,
                      proposalType: 'original',
                    },
                    {
                      id: 2,
                      proposalType: 'smart',
                    },
                  ]}
                  value={filter?.proposalType || null}
                  multiple={false}
                  onSelectChanged={(newValue) => {
                    setFilter((item) => ({
                      ...item,
                      proposalType: newValue,
                    }));
                  }}
                  emptyItem={{
                    value: null,
                    text: 'select-filter-by',
                    isDisabled: false,
                  }}
                  textInput='proposalType'
                  valueInput='id'
                  withoutSearchButton={true}
                  translationPath={translationPath}
                  parentTranslationPath={parentTranslationPath}
                />
              </div>
            </div>

            <div className='proposal-search-fields-wrapper mt-4 mb-2 '>
              <div>
                <SelectComponet
                  idRef='ActivityDatefilterByRef'
                  labelValue={t(`filter-by`)}
                  data={[{ id: 'CreatedOn', filterBy: 'created-date' }]}
                  value={filter?.filterBy || null}
                  onSelectChanged={(newValue) => {}}
                  emptyItem={{
                    value: null,
                    text: 'select-filter-by',
                    isDisabled: false,
                  }}
                  valueInput='id'
                  textInput='filterBy'
                  parentTranslationPath={parentTranslationPath}
                  translationPath={translationPath}
                  translationPathForData={translationPath}
                />
              </div>
              <div>
                <SelectComponet
                  idRef='orderByRef'
                  labelValue={t(`order-by`)}
                  data={[
                    { id: 1, orderBy: 'ascending' },
                    { id: 2, orderBy: 'descending' },
                  ]}
                  emptyItem={{
                    value: null,
                    text: 'select-order-by',
                    isDisabled: false,
                  }}
                  value={filter?.orderBy || null}
                  onSelectChanged={(newValue) => {
                    setFilter((item) => ({
                      ...item,
                      orderBy: +newValue,
                    }));
                  }}
                  wrapperClasses='mb-3'
                  isRequired
                  valueInput='id'
                  textInput='orderBy'
                  parentTranslationPath={parentTranslationPath}
                  translationPath={translationPath}
                  translationPathForData={translationPath}
                />
              </div>
            </div>
          </div>
          <div className='actionSide ml-5'>
            <ButtonBase
              onClick={onClearedAllFiltersClick}
              id='onClearedAllFiltersref'
              className='btns theme-solid bg-danger clear-all-btn max-height'
            >
              <span className='mdi mdi-filter-remove m-1' />
              {t(`clear-filters`)}
            </ButtonBase>
          </div>
        </div>
        <Tables
          data={proposalLogs?.result || []}
          headerData={[
            {
              id: 1,
              label: 'Agent-name',
              input: 'name',
            },
            {
              id: 2,
              label: 'Agent-Branch',
              input: 'branch',
            },
            {
              id: 3,
              label: 'Agent-mobile-number',
              input: 'mobileNumber',
            },
            {
              id: 4,
              label: 'Agent-Email',
              input: 'email',
            },
            {
              id: 5,
              label: 'date-time',
              input: 'createdOn',
              component: (item) => item.createdOn,
            },
            {
              id: 6,
              label: 'source-system',
              input: 'sourceSystem',
              component: (item) => item.sourceSystem,
            },
            {
              id: 7,
              label: 'action',
              input: 'actionType',
            },
            {
              id: 8,
              label: 'platform',
              input: 'platform',
            },
            {
              id: 9,
              label: 'type',
              input: 'proposalType',
            },
          ]}
          defaultActions={getTableActions()}
          actionsOptions={{
            onActionClicked: tableActionClicked,
          }}
          focusedRowChanged={focusedRowChanged}
          translationPath={translationPath}
          parentTranslationPath={parentTranslationPath}
          itemsPerPage={filter.pageSize}
          activePage={0}
        />
      </div>

      {viewDetailsProposal && (
        <ProposalHistoryViewDetailsDialog
          isOpen={viewDetailsProposal}
          activeitem={activeitem}
          onClose={() => {
            setViewDetailsProposal(false);
            setActiveitem(null);
          }}
          translationPath={translationPath}
          parentTranslationPath={parentTranslationPath}
          filter={filter}
        />
      )}
      {isPreviewDialogOpen && (
        <PreviewProposalDialog
          isOpen={isPreviewDialogOpen}
          activeitem={activeRow}
          onClose={() => {
            setIsPreviewDialogOpen(false);
            setActiveitem(null);
          }}
          translationPath={parentTranslationPath}
        />
      )}
    </>
  );
};
